export enum ProgressStatus {
  Disabled = 0,
  Active = 1,
  Complete = 2,
}
